import { render, staticRenderFns } from "./edit-department.vue?vue&type=template&id=3b4fe1ae"
import script from "./edit-department.vue?vue&type=script&lang=ts"
export * from "./edit-department.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports